import React, { useEffect, useState } from 'react'
import { Select, SelectItem, SelectPlaceholder } from '@/components/Select'
import { api } from '@/api'

const SpecialsSelect = ({
  label = 'Специальность:',
  theme = 'gray',
  valueType = 'id',
  ...props
}): React.ReactElement => {
  const [data, setData] = useState<any[]>([])

  useEffect(() => {
    api.getEducationSpecials()
      .then((data) => {
        setData(data.results)
      })
      .catch(err => {
        console.log(err)
      })
  }, [])

  if (data.length === 0) {
    return (
      <SelectPlaceholder label={label} {...props} />
    )
  }

  return (
    <Select theme={theme} placeholder='Выбери' label={label} {...props}>
      {data.map((el) => {
        return (
          <SelectItem value={el.id} key={el.id}>
            {el.name}
          </SelectItem>
        )
      })}
    </Select>
  )
}

export default SpecialsSelect
